import { NAV_GROUPS } from './navConfig';

/**
 * Telas reais que NÃO têm entrada no menu (detalhes, wizards, lotes) mas
 * precisam de identidade própria na telemetria — senão colapsam na tela-pai e
 * "quantas pessoas abrem o workspace de conferência" vira impossível de saber.
 *
 * ⚠ Ordem não importa (a resolução é por prefixo mais longo), mas o path SIM:
 * use o prefixo estável, sem o `:param`.
 */
export const TELAS_EXTRA: ReadonlyArray<{ to: string; screenId: string }> = [
  { to: '/conferencia/nova', screenId: 'conferencia-nova' },
  { to: '/conferencia/pendencias/', screenId: 'conferencia-pendencia-detalhe' },
  { to: '/conferencia/', screenId: 'conferencia-workspace' },
  { to: '/compras/metas/dimensao/lote', screenId: 'compras-metas-dimensao-lote' },
  { to: '/compras/cotacoes/', screenId: 'compras-cotacao-detalhe' },
];

interface Entrada { to: string; screenId: string; exact?: boolean }

function entradas(): Entrada[] {
  const doMenu: Entrada[] = NAV_GROUPS.flatMap(g =>
    g.itens.map(i => ({ to: i.to, screenId: i.screenId, exact: i.exact })));
  return [...doMenu, ...TELAS_EXTRA.map(t => ({ ...t }))];
}

export const TODOS_SCREEN_IDS: string[] = entradas().map(e => e.screenId);

/**
 * Resolve um pathname pro screenId da tela. Mesmo algoritmo do
 * `useRotuloRotaAtiva` (prefixo mais LONGO vence), pra rótulo e telemetria
 * nunca discordarem sobre "que tela é esta".
 *
 * Devolve `null` pra rota desconhecida — o beacon prefere não reportar a
 * reportar chave inventada.
 */
export function resolverScreenId(pathname: string): string | null {
  const candidatos = entradas().filter(e =>
    e.exact ? pathname === e.to
            : pathname === e.to || (e.to !== '/' && pathname.startsWith(e.to)));
  if (candidatos.length === 0) return null;
  return candidatos.sort((a, b) => b.to.length - a.to.length)[0].screenId;
}
